import "./about.css"
import ME from "../../assets/EU.jpg"
import {FaAward} from "react-icons/fa"
import {VscFolderLibrary} from 'react-icons/vsc'
import { useTranslation } from "react-i18next";



const About = () => {
  const { t } = useTranslation();

  return (
    <section id='about'>
    
      <h5>{t("gettoknow")}</h5>
      <h2>{t("aboutme")}</h2>

      <div className="container about__container">
        
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>{t("experience")}</h5>
              <small>{t("years")}</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>{t("projects")}</h5>
              <small>{t("complete_projects")}</small>
            </article>
          </div>
          <p className='about_text'>
            {t("abouttext")}
          </p>

          <a href="#contact" className='btn btn-primary'>{t("lets")}</a>
        </div>
      </div>
     
      
    </section>
  )
}

export default About